import type { ExportedVersionOptions } from './types';

/** Whether the exported version becomes the documentation's current one: yes, unless the user said no. */
export function isExportedVersionMadeCurrent(version: ExportedVersionOptions | undefined): boolean {
  return version?.makeCurrent ?? true;
}
